export const schedulingProviderTabs = ['My Care Team', 'New Provider', 'Services'];

export default {
  GET_SPECIALTY_PROVIDER: {
    MOBILE: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description:
          'Sorry, there was an issue fetching providers with the selected specialty. Pull down to refresh and try again.'
      }
    },
    WEB: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description: 'Sorry, there was an issue fetching providers with the selected specialty.'
      }
    },
    NO_DATA: {
      message: 'No providers matched your criteria. Please try again.'
    }
  },
  GET_SPECIALTIES: {
    MOBILE: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description:
          'Sorry, there was an issue fetching the list of specialties. Pull down to refresh and try again.'
      }
    },
    WEB: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description: 'Sorry, there was an issue fetching the list of specialties.'
      }
    },
    NO_DATA: {
      message: 'There are no specialties.'
    }
  },
  GET_MY_DOCTORS: {
    MOBILE: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description:
          'Sorry, there was an issue fetching your list of doctors. Pull down to refresh and try again.'
      }
    },
    WEB: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description: 'Sorry, there was an issue fetching your list of doctors.'
      }
    },
    NO_DATA: {
      message:
        'The selected patient has yet to save a Primary Care Physician or Preferred Provider(s).'
    }
  },
  NO_ONLINE_NPV_SLOTS: {
    severity: 'info' as 'info',
    title: 'is not accepting new patients through online scheduling at this time.'
  },
  CALL_TO_SCHEDULE: 'Call the clinic to schedule'
};
